import type { FC } from "react"
import {
	IconCheckDoubleOutline18 as CheckCheck,
	IconCubeOutline18 as Cube,
	IconPlusOutline18 as Plus,
} from "nucleo-ui-outline-18"
import { useWindowSize } from "react-use"
import resolveConfig from "tailwindcss/resolveConfig"

import {
	Button,
	DropdownMenu,
	DropdownMenuItem,
	IconButton,
	LinearIcon,
} from "@productlane/ui"

import { RoleCheck } from "@/components/shared/role-check"
import tailwindConfig from "../../../../tailwind.config"

const fullConfig = resolveConfig(tailwindConfig)

interface AddDropdownProps {
	onCreateProject: () => void
	onCreateIssue: () => void
	onImportIssues: () => void
	isLinearConnected: boolean
	/** Render the trigger as a compact outline icon button instead of the "+ New" button. */
	compact?: boolean
}

export const AddDropdown: FC<AddDropdownProps> = ({
	onCreateProject,
	onCreateIssue,
	onImportIssues,
	isLinearConnected,
	compact = false,
}) => {
	const { width } = useWindowSize()
	const sm = fullConfig.theme.screens.sm

	const trigger = compact ? (
		<IconButton Icon={Plus} variant="outline" />
	) : width >= parseInt(sm) ? (
		<Button Icon={Plus} variant="outline">
			New
		</Button>
	) : (
		<IconButton Icon={Plus} />
	)

	return (
		<RoleCheck not={["VIEWER"]}>
			<DropdownMenu trigger={trigger} contentProps={{ align: "end" }}>
				<DropdownMenuItem
					Icon={Cube}
					onClick={onCreateProject}
					disabled={!isLinearConnected}
				>
					New project
				</DropdownMenuItem>
				<DropdownMenuItem Icon={CheckCheck} onClick={onCreateIssue}>
					New issue
				</DropdownMenuItem>
				<DropdownMenuItem
					Icon={LinearIcon as unknown as typeof CheckCheck}
					onClick={onImportIssues}
				>
					Import issues
				</DropdownMenuItem>
			</DropdownMenu>
		</RoleCheck>
	)
}
